import { BASE_URL } from "../config/api";

const getToken = () => localStorage.getItem("token");

// List files/folders
export const listFiles = async (path = '') => {
  const response = await fetch(`${BASE_URL}/files?path=${encodeURIComponent(path)}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to load files');
  return data;
};

// Upload files
export const uploadFiles = async (files, currentPath = '') => {
  const formData = new FormData();
  Array.from(files).forEach(file => {
    formData.append('files', file);
  });

  const response = await fetch(`${BASE_URL}/files/upload?path=${encodeURIComponent(currentPath)}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData
  });
  
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Upload failed');
  return data;
};

// Create folder
export const createFolder = async (folderPath) => {
  const response = await fetch(`${BASE_URL}/files/folder`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({ path: folderPath })
  });
  
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to create folder');
  return data;
};

// Delete item
export const deleteItem = async (itemPath) => {
  const response = await fetch(`${BASE_URL}/files?path=${encodeURIComponent(itemPath)}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    }
  });
  
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Delete failed');
  return data;
};

// Download item - returns the URL for download
export const getDownloadUrl = (itemPath) => {
  return `${BASE_URL}/files/download?path=${encodeURIComponent(itemPath)}`;
};

// List all folders
export const listAllFolders = async () => {
  const response = await fetch(`${BASE_URL}/files/all-folders`);
  const data = await response.json();
  if (!response.ok) throw new Error('Failed to load folder tree');
  return data;
};